import React from "react";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import FaqAccordion from "../Faq/FaqAccordion";

const FAQS = [
  {
    question: "Why should I become a sponsor?",
    answer:
      "By becoming a sponsor, you make a direct and meaningful impact on the lives of deserving individuals. You help shape a brighter future by providing them with the opportunity to reach their full potential.",
  },
  {
    question: "How does the sponsorship process work?",
    answer:
      "Sponsorship is simple and customizable! You can:\n\n- Create a named scholarship: Leave your legacy and promote your values.\n- Sponsor anonymously: Focus on the impact, not the recognition.\n- Set your giving criteria: Target specific areas of need or demographics.\n- Select recipients: Be personally involved in the choice (if you'd like).\n- Optionally meet scholarship recipients: Build a connection.",
  },
  {
    question: "What level of control do I have over my sponsorship?",
    answer:
      "You have a significant amount of control over your sponsorship experience. Choose how visible you want to be, set the criteria for your scholarship, and decide how involved you'd like to be in the selection process.",
  },
  {
    question: "Can I track the impact of my sponsorship?",
    answer:
      "Yes! We believe in full transparency. You'll receive regular updates on the progress of your scholarship recipients, so you can see the tangible difference your contribution is making.",
  },
  {
    question: "Are there different sponsorship levels?",
    answer:
      "Yes, we offer a range of sponsorship levels to accommodate different budgets and goals. Contact us to discuss options tailored to your needs.",
  },
  {
    question: "How do I get started?",
    answer:
      "The first step is easy! Use the 'Become a sponsor' button on this page or contact us directly to begin your sponsorship journey.",
  },
];

export default function SonsorFaq() {
  const ref = useScrollAnimation();

  return (
    <section ref={ref} className="py-24 bg-white relative">
      <div className="max-w-[1000px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 lg:mb-20 gap-8 animate-on-scroll animate-fade-up">
          <div className="w-full lg:w-1/2">
            <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-gray-400 mb-6 flex items-center gap-3">
              <span className="block w-8 h-[2px] bg-primary" />
              More information
            </div>
            <h2 className="text-[#0b0f19] text-3xl md:text-5xl font-bold">
              Frequently asked questions<span className="text-primary">.</span>
            </h2>
          </div>
          <div className="w-full lg:w-1/2 flex lg:justify-end">
            <p className="text-gray-500 text-lg max-w-[400px] leading-relaxed border-l border-[#d15424]/30 pl-6">
              Everything sponsors usually ask before funding a seat, answered in one place.
            </p>
          </div>
        </div>

        <div className="animate-on-scroll animate-fade-up delay-200">
          <FaqAccordion faqs={FAQS} />
        </div>
      </div>
    </section>
  );
}
